import baseStore from '~/base_store';

export const assureModuleRegistered = (store, name, module) => {
    if (!store.state[name]) {
        store.registerModule(name, module);
    }
};

export const registerModule = (name, module) => {
    assureModuleRegistered(baseStore, name, module);
};